import { UiEmailSignupModel } from "../../models";

import { mockLinkButtonThemeModel, mockLinkButtonThemeModelContent } from "./";

export function mockUiEmailSignupModel({
    id = "email-signup-1234",
    type = "uiEmailSignup",
    locale = "en",
    content = mockUiEmailSignupModelContent()
}: Partial<UiEmailSignupModel> = {}): UiEmailSignupModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiEmailSignupModelContent = UiEmailSignupModel["content"];

export function mockUiEmailSignupModelContent({
    entryTitle = "Example Email Signup",
    emailLabel = "Email",
    buttonText = "Sign up",
    theme = mockLinkButtonThemeModel({
        content: mockLinkButtonThemeModelContent({
            appearance: "Primary"
        })
    }),
    ...optionals
}: Partial<UiEmailSignupModelContent> = {}): UiEmailSignupModelContent {
    return {
        entryTitle,
        emailLabel,
        buttonText,
        theme,
        ...optionals
    };
}
